import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, FieldArray } from 'redux-form/immutable';

import TextInput from '../../components/form-input-text';
import { sendBirdService } from '../../utils/sendbird-service';
import CheckboxInput from '../../components/form-input-checkbox';
import { setSendbirdChannel, setCurrentDisccusion } from '../../containers/discussion/actions';
import { getRoleMembers } from '../../selectors/campaign-selectors';
import { CAMPAIGN_OWNER, CAMPAIGN_ADMIN, TEAM_MEMBER, CLIENT, INFLUENCER, TALENT_AGENT, PRODUCTION_COMPANY } from '../../utils/static-configuration';
import { createDiscussion } from '../../utils/jsonapi-functions/discussions';
import { addDiscussionToCampaign } from '../../utils/jsonapi-functions/campaigns';

const renderMembers = ({ members, fields }) => (
  <div>
    { fields.map((member, index) => (
      <div key={index}>
        <h4>Member #{index}</h4>
        <p>Permission id: {members[index].permissionId}</p>
        <p>Name: {members[index].name}</p>
        <Field
          name={`${member}.addMember`}
          type="checkbox"
          component={CheckboxInput}
          label="name"
        />
      </div>
      ))}
  </div>
);

class DiscussionCreate extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  async extractAddedMembers(addedMembersList, sendbirdMembers, formDataList) {
    formDataList.forEach(addableMember => {
      const addMember = addableMember.get('addMember');

      if (addMember) {
        addedMembersList.push({ type: 'campaignPermission', id: addableMember.get('permissionId') });
        sendbirdMembers.push(addableMember.get('userId'));
      }
    });
  }

  async postDiscussion(formData) {
    const discussionName = formData.get('discussionName');
    const addedTeamMembers = formData.get('addableTeamMembers');
    const addedClientMembers = formData.get('addableClientMembers');
    const addedInfluencerMembers = formData.get('addableInfluencerMembers');
    const addedTalentManagerMembers = formData.get('addableTalentManagerMembers');
    const addedProductionCompanyMembers = formData.get('addableProductionCompanyMembers');

    const sendbirdMembers = [];
    const addedMembersList = [];
    const organisationIds = [];

    // Add the user creating to the discussion to the members list
    const myPermissionId = this.props.myPermissionId;
    const myUserId = this.props.userData.get('id');
    const myOrganisationId = this.props.userData.get('organisationId');

    addedMembersList.push({ type: 'campaignPermission', id: myPermissionId });
    sendbirdMembers.push(myUserId);
    organisationIds.push(myOrganisationId);

    this.extractAddedMembers(addedMembersList, sendbirdMembers, addedTeamMembers, organisationIds);
    this.extractAddedMembers(addedMembersList, sendbirdMembers, addedClientMembers, organisationIds);
    this.extractAddedMembers(addedMembersList, sendbirdMembers, addedInfluencerMembers, organisationIds);
    this.extractAddedMembers(addedMembersList, sendbirdMembers, addedTalentManagerMembers, organisationIds);
    this.extractAddedMembers(addedMembersList, sendbirdMembers, addedProductionCompanyMembers, organisationIds);

    const campaignId = this.props.campaign.get('id');

    try {
      await sendBirdService.connectSendbirdUser(myUserId);

      const channelURL = await sendBirdService.createSendbirdChannel(sendbirdMembers);

      // TODO OrganisationIDs list is not currently being completed.
      const discussionData = {
        discussionName,
        addedMembersList,
        channelURL,
        campaignId,
        organisationIds,
      };

      const discussion = await createDiscussion(discussionData);

      await addDiscussionToCampaign(campaignId, discussion);

      this.context.router.push(`/campaign/${campaignId}`);
    } catch (error) {
      // TODO Handle errors
    }
  }

  render() {
    const {
      handleSubmit,
      members,
      userData,
      teamMembers,
      clientMembers,
      influencerMembers,
      talentManagerMembers,
      productionCompanyMembers,
    } = this.props;
    const userId = userData.get('id');

    return (
      <div className="page">

        <div className="page-content">

          { members.map(member => {
            /* Users creating the discussion must be included. */
            if (userId === member.getIn(['user', 'id'])) return '';
            return (<p>name: {member.get('name')}, role: {member.get('role')}</p>);
          })}

          <form onSubmit={handleSubmit(this.postDiscussion.bind(this))}>
            <div className="hero left">
              <h1>Create a discussion</h1>
            </div>
            <div className="grid">
              <div className="grid-4-6">
                <Field
                  name="discussionName"
                  type="text"
                  label="Discussion title"
                  component={TextInput}
                  placeholder="Discussion name"
                />
                <div className="spacer" />
                <h3>Team members</h3>
                <FieldArray
                  name="addableTeamMembers"
                  members={teamMembers}
                  component={renderMembers}
                />
                <h3>Clients</h3>
                <FieldArray
                  name="addableClientMembers"
                  members={clientMembers}
                  component={renderMembers}
                />
                <h3>Influencers</h3>
                <FieldArray
                  name="addableInfluencerMembers"
                  members={influencerMembers}
                  component={renderMembers}
                />
                <h3>Talent managers</h3>
                <FieldArray
                  name="addableTalentManagerMembers"
                  members={talentManagerMembers}
                  component={renderMembers}
                />
                <h3>Production companies</h3>
                <FieldArray
                  name="addableProductionCompanyMembers"
                  members={productionCompanyMembers}
                  component={renderMembers}
                />
              </div>
            </div>
            <div className="hero">
              <button className="large rose wide" type="submit">
                <p>Create discussion</p>
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

DiscussionCreate.propTypes = {
  routeParams: React.PropTypes.object,
};

function validate(values) {
  const errors = {};

  const message = values.get('message');
  if (!message) errors.message = 'Please enter a message';

  // TODO Do the rest of the validation
  return errors;
}

const mapStateToProps = state => ({
  campaign: state.campaign.get('campaign'),
  members: state.members.get('members'),
  userData: state.userData.get('userData'),
  myPermissionId: state.campaign.get('myPermissionId'),
  loading: state.discussion.get('loading'),
  myUserRole: state.campaign.get('myUserRole'),
  teamMembers: getRoleMembers(state, [TEAM_MEMBER, CAMPAIGN_OWNER, CAMPAIGN_ADMIN]),
  clientMembers: getRoleMembers(state, [CLIENT]),
  influencerMembers: getRoleMembers(state, [INFLUENCER]),
  talentManagerMembers: getRoleMembers(state, [TALENT_AGENT]),
  productionCompanyMembers: getRoleMembers(state, [PRODUCTION_COMPANY]),
  initialValues: {
    addableTeamMembers: getRoleMembers(state, [TEAM_MEMBER, CAMPAIGN_OWNER, CAMPAIGN_ADMIN]),
    addableClientMembers: getRoleMembers(state, [CLIENT]),
    addableInfluencerMembers: getRoleMembers(state, [INFLUENCER]),
    addableTalentManagerMembers: getRoleMembers(state, [TALENT_AGENT]),
    addableProductionCompanyMembers: getRoleMembers(state, [PRODUCTION_COMPANY]),
  },
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onSetSendbirdChannel: channelURL => dispatch(setSendbirdChannel(channelURL)),
    onSetCurrentDisccusion: discussionId => dispatch(setCurrentDisccusion(discussionId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'DiscussionMessages',
    validate,
  })(DiscussionCreate),
);



/** WEBPACK FOOTER **
 ** ./src/containers/discussion-create/index.js
 **/